import React from "react";
import { Star } from "lucide-react";

export function StarRating({ rating = 0, count, size = 14, className = "" }) {
  const r = Math.round(Number(rating) * 2) / 2;
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} data-testid="star-rating">
      <Star size={size} className="fill-current" style={{ color: "#FFC400" }} />
      <span className="font-mono-num font-semibold">{Number(rating).toFixed(1)}</span>
      {typeof count === "number" && <span className="text-muted-foreground text-xs">({count})</span>}
      {/* hidden accessible value */}
      <span className="sr-only">{r} out of 5</span>
    </span>
  );
}
